/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {configureAdminResourceStates} from '../../common/controller/admin-resource-routing';
import {ContextServiceConfigurationResource} from '../../../components/api/resources/resource/context-service-configuration.resource';


export function contextServiceConfigurationStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper(
          'context-service-configurations.context-service-configuration',
          ContextServiceConfigurationResource,
          'app.adm',
          'app/admin'
        );
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'ContextServiceConfiguration',
          editTag: 'adn-context-service-configuration-edit-page',
          listTag: 'adn-context-service-configuration-list-page',
          listData: {
            app: ['ADVERTISING', 'DATA']
          }
        });
  }, adnRouterHelper);
}
